'use client';

import { c as _c } from "react/compiler-runtime";
import { Drawer, Heading, TextPassage } from '@petsmart-ui/sparky';
import { type ReactElement, useMemo } from 'react';
import { LoginEvents } from '@libs/analytics';
import { AccountDrawerType, cartHasVetDietItem, cartHasVetRxItem, PageType, useCart, useOptimizely, usePageLayout, useUserSession } from '@libs/common-next';
import type { LoyaltySignIn } from '@libs/contentful';
import { InterstitialSignIn } from '../InterstitialSignIn';
import { generateVelocityCreateAccountUrl } from './generateCreateAccountUrl';
import './SignInDrawer.scss';
export function SignInDrawer(t0) {
  const $ = _c(35);
  const {
    data
  } = t0;
  const {
    cart
  } = useCart();
  const {
    isSoftAuthenticated
  } = useUserSession();
  const {
    context
  } = useOptimizely();
  let t1;
  if ($[0] !== cart) {
    t1 = cart && cartHasVetRxItem(cart);
    $[0] = cart;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cartHasRx = t1;
  let t2;
  if ($[2] !== cart) {
    t2 = cart && cartHasVetDietItem(cart);
    $[2] = cart;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cartHasVetDiet = t2;
  const showRxMessage = cartHasRx || cartHasVetDiet;
  const {
    accountDrawersOpen,
    removeAccountDrawers,
    signInDrawerProps,
    pageType
  } = usePageLayout();
  let t3;
  bb0: {
    let t4;
    if ($[4] !== signInDrawerProps) {
      t4 = signInDrawerProps ?? {};
      $[4] = signInDrawerProps;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    const {
      productToAddToWishlist
    } = t4;
    switch (pageType) {
      case PageType.PLP:
      case PageType.PDP:
        {
          if (productToAddToWishlist) {
            const t5 = productToAddToWishlist as string;
            let t6;
            if ($[6] !== t5) {
              t6 = generateVelocityCreateAccountUrl("wishlist", t5);
              $[6] = t5;
              $[7] = t6;
            } else {
              t6 = $[7];
            }
            t3 = t6;
            break bb0;
          }
          t3 = undefined;
          break bb0;
        }
      default:
        {
          t3 = undefined;
        }
    }
  }
  const createAccountHref = t3;
  let t4;
  if ($[8] !== data?.items?.[0]?.fields?.items) {
    t4 = data?.items?.[0]?.fields?.items || [];
    $[8] = data?.items?.[0]?.fields?.items;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const benefitItems = t4;
  let t5;
  if ($[10] !== accountDrawersOpen) {
    t5 = accountDrawersOpen?.includes(AccountDrawerType.SIGN_IN);
    $[10] = accountDrawersOpen;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const isActive = t5;
  let t6;
  if ($[12] !== removeAccountDrawers) {
    t6 = () => {
      removeAccountDrawers([AccountDrawerType.SIGN_IN]);
    };
    $[12] = removeAccountDrawers;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = signInDrawerProps?.signInTitle as string || data?.signInTitle;
  let t8;
  if ($[14] !== t7) {
    t8 = <Drawer.Header><Heading data-testid="sign-in-drawer-heading-1" id="drawer-heading-1" tagName="h4" size="title">{t7}</Heading></Drawer.Header>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== showRxMessage) {
    t9 = showRxMessage && <><TextPassage>Pharmacy and Vet Diet orders require an account to checkout. Please sign in or create an account to complete your purchase.</TextPassage><br /></>;
    $[16] = showRxMessage;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = data?.title;
  const t11 = data?.isSoftAuthenticatedServer;
  const t12 = isSoftAuthenticated ? LoginEvents.REAUTHENTICATE_SIGN_IN_DRAWER : LoginEvents.SIGN_IN_DRAWER;
  let t13;
  if ($[18] !== context) {
    t13 = () => {
      context?.trackEvent("sign_ins");
    };
    $[18] = context;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== benefitItems || $[21] !== createAccountHref || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t13) {
    t14 = <div className="sign-in-drawer__body"><InterstitialSignIn itemsTitle={t10} benefitItems={benefitItems} isInDrawer={true} isSoftAuthenticatedServer={t11} createAccountHref={createAccountHref} location={t12} onSuccessfulSignIn={t13} displayAutoshipDescription={true} /></div>;
    $[20] = benefitItems;
    $[21] = createAccountHref;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t9) {
    t15 = <Drawer.Body>{t9}{t14}</Drawer.Body>;
    $[27] = t14;
    $[28] = t9;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== isActive || $[31] !== t15 || $[32] !== t6 || $[33] !== t8) {
    t16 = <Drawer data-testid="sign-in-drawer" align="right" isActive={isActive} onClose={t6} ariaLabelledBy="drawer-heading-1" className="sign-in-drawer">{t8}{t15}</Drawer>;
    $[30] = isActive;
    $[31] = t15;
    $[32] = t6;
    $[33] = t8;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}